"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAmplitudeExperiments = initAmplitudeExperiments;
const constants_1 = require("core/constants");
function initAmplitudeExperiments() {
    const apiKey = constants_1.AMPLITUDE_API_KEY;
    if (apiKey) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://cdn.amplitude.com/script/${apiKey}.experiment.js`;
        document.head.appendChild(script);
    }
    else {
        console.error('AMPLITUDE_API_KEY is not defined in the environment variables.');
    }
}
